import React, { useEffect, useState } from 'react';
import connect from "react-redux/es/components/connect";
import { useNavigate } from "react-router-dom";
import Box from '@mui/system/Box';
import { TextField, Checkbox, Button, Select, MenuItem, OutlinedInput } from '@mui/material';
import { FormLabel, FormControl, FormGroup, FormControlLabel, FormHelperText, Accordion, AccordionSummary, AccordionDetails, IconButton, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { getVFASOList, formatDate, actionGetTransactionList } from "../store/action/RemoteActionSupervisor";
import PaginationBar from './common/PaginationBar';
import translate from "../i18n/translate";
import { resetTimout } from "./common/FirebaseSupervisor";

const TransactionList = (props) => {
    const navigate = useNavigate();
    const [vfaspList, setVfaspList] = useState([]);
    const [searchVfaspID, setSearchVfaspID] = useState(' ');
    const [language, setLanguage] = useState("");
    const [searchField, setSearchField] = useState(0);
    const [searchKeyword, setSearchKeyword] = useState('');
    const [searchBuySellType, setSearchBuySellType] = useState(0);
    const [searchTransactionStatus, setSearchTransactionStatus] = useState('ALL');
    const [searchOtcFlag, setSearchOtcFlag] = useState(false);
    const [searchQuantityOperator, setSearchQuantityOperator] = useState(1);
    const [searchQuantity, setSearchQuantity] = useState(0);
    const [searchDateFrom, setSearchDateFrom] = useState(null);
    const [searchDateTo, setSearchDateTo] = useState(null);
    const [searchSuspiciousFlag, setSearchSuspiciousFlag] = useState(false);
    const [transactionList, setTransactionList] = useState([]);
    const [totalRowCount, setTotalRowCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const ROWS_PER_PAGE = process.env.REACT_APP_ROWSPERPAGE ? parseInt(process.env.REACT_APP_ROWSPERPAGE) : 50;

    const onClickSearch = (pageNo) => {
        resetTimout();
        const requestBody = {
            SearchVFASPID: searchVfaspID.trim(),
            SearchField: searchField,
            SearchKeyword: searchKeyword,
            SearchDateFrom: searchDateFrom ? formatDate(searchDateFrom) : '',
            SearchDateTo: searchDateTo ? formatDate(searchDateTo) : '',
            SearchTransactionStatus: searchTransactionStatus.trim(),
            SearchOtcFlag: searchOtcFlag === true ? 1 : 0,
            SearchQuantityOperator: searchQuantityOperator,
            SearchQuantity: searchQuantity,
            SearchBuySellFlag: searchBuySellType,
            SearchSuspiciousFlag: searchSuspiciousFlag === true ? 1 : 0,
            SearchPageNo: pageNo,
            SearchPageSize: ROWS_PER_PAGE
        };
        props.actionGetTransactionList(requestBody);
        setTransactionList([]);
        setCurrentPage(pageNo);
        setIsButtonClicked(true);
    };

    const handleChange = (e) => {
        resetTimout();
        let eventValue = e.target.value;
        switch (e.target.name) {
            case "id_SearchField":
                eventValue = parseInt(eventValue);
                setSearchField(eventValue);
                if (eventValue === 0) {
                    setSearchKeyword("");
                }
                break;
            case "id_SearchKeyword":
                setSearchKeyword(eventValue);
                break;
            case "id_TransactionStatus":
                setSearchTransactionStatus(eventValue);
                break;
            case "id_BuySell":
                setSearchBuySellType(eventValue);
                break;
            case "id_OtcFlag":
                setSearchOtcFlag(e.target.checked);
                break;
            case "id_SuspiciousFlag":
                setSearchSuspiciousFlag(e.target.checked);
                break;
            case "id_QuantityOperator":
                setSearchQuantityOperator(eventValue);
                break;
            case "id_Quantity":
                setSearchQuantity(eventValue);
                break;
            case "search-vfasp":
                setSearchVfaspID(eventValue);
                break;
            default:
                console.log(e.target.name);
        }
    };

    const handleDateFromChange = (e) => {
        resetTimout();
        setSearchDateFrom(e);
    };

    const handleDateToChange = (e) => {
        resetTimout();
        setSearchDateTo(e);
    };

    const goToTransactionDetails = (tid) => {
        resetTimout();
        navigate('/transactiondetails?TID=' + tid);
    };

    useEffect(() => {
        if (props?.searchResult) {
            setTransactionList(props.searchResult);
            if (currentPage === 1) {
                if (props.searchResult.length > 0) {
                    setTotalRowCount(props.searchResult[0].TotalRowCount);
                } else {
                    setTotalRowCount(0);
                }
            }
            setIsButtonClicked(false);
        } else {
            setTotalRowCount(0);
        }
    }, [props.searchResult]);

    useEffect(() => {
        setLanguage(localStorage.getItem("locale"));
        const requestBody = {
            SearchField: 0,
            SearchKeyword: '',
            SearchPageNo: 1,
            SearchPageSize: ROWS_PER_PAGE
        };
        props.actionGetTransactionList(requestBody);
        setIsButtonClicked(true);
        setVfaspList(getVFASOList());
    }, []);

    return (
        <div className="user-panel">
            <h2 className="user-panel-title">{translate('Menu-TransactionList')}</h2>

            <Box sx={{ display: 'flex' }}>
                <Accordion sx={{ display: 'nowrap', marginBottom: '10' }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                        <Typography>{translate('Filters')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <FormControl required component="fieldset" sx={{ m: 3, width: 160 }} variant="standard">
                            <FormLabel component="legend" required={false}>{translate('Search-CASP')}</FormLabel>
                            <Select style={{ minWidth: 80 }} name="search-vfasp" labelId="vfasp-label" value={searchVfaspID} onChange={handleChange} className="input-item-label" input={<OutlinedInput label={translate('Search-CASP')} />}>
                                <MenuItem value={' '}><em>{translate('Search-All')}</em></MenuItem>
                                {vfaspList?.map((vfasp, index) => {
                                    return <MenuItem key={vfasp.ClientID} value={vfasp.ClientID}>{vfasp.ClientName}</MenuItem>
                                })
                                }
                                <MenuItem key={process.env.REACT_APP_VFASP_CODE} value={process.env.REACT_APP_VFASP_CODE}>{'Progress'}</MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl required component="fieldset" sx={{ m: 3, width: 250 }} variant="standard">
                            <Select id="id_SearchField" name="id_SearchField" value={searchField} label={translate('SearchField')} onChange={handleChange}>
                                <MenuItem value={0}><em>{translate('Select-SearchField')}</em></MenuItem>
                                <MenuItem value={2}>{translate('TransactionID')}</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl required component="fieldset" sx={{ m: 3, width: 250 }} variant="standard">
                            <TextField id="id_SearchKeyword" name="id_SearchKeyword" value={searchKeyword} label={translate('SearchKeyword')} variant="outlined" size="small" onChange={handleChange} />
                        </FormControl>

                        <FormControl required component="fieldset" sx={{ m: 3, width: 250 }} variant="standard">
                            <Select id="id_TransactionStatus" name="id_TransactionStatus" value={searchTransactionStatus} label={translate('Search-TransactionStatus')} onChange={handleChange}>
                                <MenuItem value="ALL"><em>{translate('Search-All')}</em></MenuItem>
                                <MenuItem value="PROCESSED">{translate('Txn-Completed')}</MenuItem>
                                <MenuItem value="IN-PROGRESS">{translate('Txn-Progress')}</MenuItem>
                                <MenuItem value="PENDING">{translate('Txn-Pending')}</MenuItem>
                                <MenuItem value="CANCELLED">{translate('Txn-Cancelled')}</MenuItem>
                                <MenuItem value="DECLINED">{translate('Txn-Declined')}</MenuItem>
                                <MenuItem value="EXPIRED">{translate('Txn-Expired')}</MenuItem>
                                <MenuItem value="ERROR">{translate('Txn-Error')}</MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl required component="fieldset" sx={{ m: 3 }} variant="standard">
                            <FormLabel component="legend" required={false}>{translate('Search-BuySell')}</FormLabel>
                            <Select style={{ minWidth: 80 }} id="id_BuySell" name="id_BuySell" labelId="buySell-label" value={searchBuySellType} onChange={handleChange} className="input-item-label" input={<OutlinedInput label={translate('Search-BuySell')} />}>
                                <MenuItem value="0"><em>{translate('Search-All')}</em></MenuItem>
                                <MenuItem value="1">{translate('Buy')}</MenuItem>
                                <MenuItem value="2">{translate('Sell')}</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
                            <FormControlLabel
                                control={
                                    <Checkbox checked={searchOtcFlag} onChange={handleChange} name="id_OtcFlag" />
                                }
                                label={translate('Search-OTC')}
                            />
                        </FormControl>

                        <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
                            <FormControlLabel
                                control={
                                    <Checkbox checked={searchSuspiciousFlag} onChange={handleChange} name="id_SuspiciousFlag" />
                                }
                                label={translate('Search-Suspicious')}
                            />
                        </FormControl>

                        <FormControl required component="fieldset" sx={{ m: 3 }} variant="standard">
                            <FormGroup style={{ maxWidth: 80 }}>
                                <FormLabel component="legend" required={false}>{translate('Search-Quantity')}</FormLabel>
                                <Select id="id_QuantityOperator" name="id_QuantityOperator" labelId="quantityOperator-label" value={searchQuantityOperator} onChange={handleChange} className="input-item-label">
                                    <MenuItem value="1"><em>{'='}</em></MenuItem>
                                    <MenuItem value="2">{'>'}</MenuItem>
                                    <MenuItem value="3">{'<'}</MenuItem>
                                </Select>
                                <TextField variant="outlined" id="id_Quantity" name="id_Quantity" onChange={(e) => setSearchQuantity(e.target.value)} />
                            </FormGroup>
                        </FormControl>

                        <FormControl required component="fieldset" sx={{ m: 3, width: 160 }} variant="standard">
                            <DesktopDatePicker
                                id="id_DateFrom"
                                name="id_DateFrom"
                                label={translate('Search-DateFrom')}
                                inputFormat="yyyy/MM/dd"
                                value={searchDateFrom}
                                onChange={handleDateFromChange}
                                className='input-bordered'
                                renderInput={(params) => <TextField {...params} />}
                            />
                            <DesktopDatePicker
                                id="id_DateTo"
                                name="id_DateTo"
                                label={translate('Search-DateTo')}
                                inputFormat="yyyy/MM/dd"
                                value={searchDateTo}
                                onChange={handleDateToChange}
                                className='input-bordered'
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </FormControl>

                        <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
                            <Button variant="contained" disabled={isButtonClicked ? true : false} onClick={() => onClickSearch(1)}>{translate('btnSearch')}</Button>
                        </FormControl>
                    </AccordionDetails>
                </Accordion>
            </Box>

            <div className="gaps-3x" />
            <table className="adminTable" style={{ width: 1010 }}>
                <tbody>
                    <tr className="adminTR">
                        <th className="adminTH" style={{ width: '6%' }}>{translate('VFASPID')}</th>
                        <th className="adminTH" style={{ width: '18%' }}>{translate('TransactionID')}</th>
                        <th className="adminTH" style={{ width: '12%' }}>{translate('TransactionStatus')}</th>
                        <th className="adminTH" style={{ width: '12%' }}>{translate('DateTime')}</th>
                        <th className="adminTH" style={{ width: '6%' }}>{translate('BuySell')}</th>
                        <th className="adminTH" style={{ width: '8%' }}>{translate('Tokens')}</th>
                        <th className="adminTH" style={{ width: '8%' }}>{translate('UnitPrice')}</th>
                        <th className="adminTH" style={{ width: '8%' }}>{translate('Amount')}</th>
                        <th className="adminTH" style={{ width: '8%' }}>{translate('GasFee')}</th>
                        <th className="adminTH" style={{ width: '7%' }}>{translate('Commission')}</th>
                        <th className="adminTH" style={{ width: '7%' }}>{translate('Suspicious')}</th>
                    </tr>
                    {transactionList?.map((txn, index) => {
                        return <tr className="adminTR" key={txn.AUTORECID}>
                            <td className="adminTD" width='6%' align='center'>{txn.VFASPID}</td>
                            <td className="adminTD" width='18%' align='center'><a href='#' onClick={event => goToTransactionDetails(txn.TransactionID)}>{txn.TransactionID}</a></td>
                            <td className="adminTD" width='12%' align='center'>
                                {
                                    (txn.ProcessStatus === "PROCESSED") ? translate('Txn-Completed') :
                                        (txn.TxnStatus === "CANCELLED") ? translate('Txn-Cancelled') :
                                            (txn.TxnStatus === "DECLINED") ? translate('Txn-Declined') :
                                                (txn.ProcessStatus === "IN-PROGRESS") ? translate('Txn-Progress') :
                                                    (txn.TxnStatus === "EXPIRED") ? translate('Txn-Expired') :
                                                        (txn.TxnStatus === "ERROR") ? translate('Txn-Error') : translate('Txn-Pending')
                                }
                            </td>
                            <td className="adminTD" width='12%' align='left'>{txn.DateCreated}</td>
                            <td className="adminTD" width='6%' align='center'>
                                <div className={(txn.BuySellFlag === 2 || txn.BuySellFlag === 3 || txn.BuySellFlag === 8 || txn.BuySellFlag === 9 || txn.BuySellFlag === 12) ? 'Message-Red' : 'Message-Blue'}>{txn.BuySellFlag === 5 ? translate('Transaction-Bonus') : (txn.BuySellFlag === 4 || txn.BuySellFlag === 3) ? translate('Transaction-Gift') : (txn.BuySellFlag === 2 || txn.BuySellFlag === 8 || txn.BuySellFlag === 9 || txn.BuySellFlag === 12) ? translate('Transaction-Sell') : translate('Transaction-Buy')}</div>
                            </td>
                            <td className="adminTD" width='8%' align='right'>
                                {((txn.BuySellFlag === 2 || txn.BuySellFlag === 7 || txn.BuySellFlag === 12) && txn.OtcFlag === 1 && (txn.UsedQuantity > 0 || txn.PendingQuantity > 0) && (txn.UsedQuantity < txn.Quantity)) ?
                                    <div>
                                        <span>{txn.BuySellFlag === 2 ? '-' : ''}{txn.UsedQuantity + txn.PendingQuantity}</span><br />
                                        <span>({txn.UsedQuantity + txn.PendingQuantity}/{txn.Quantity})</span>
                                    </div>
                                    :
                                    <>
                                        <span>{(txn.BuySellFlag === 2 || txn.BuySellFlag === 3 || txn.BuySellFlag === 8 || txn.BuySellFlag === 9 || txn.BuySellFlag === 12) ? '-' : '+'}{txn.Quantity}</span>
                                        <br />
                                    </>
                                }
                                {txn.CryptoAsset}
                            </td>
                            <td className="adminTD" width='8%' align='right'>
                                {txn.UnitPrice}<br />{txn.Currency === 'BTC' ? translate('Bitcoin') : translate('Euro')}
                            </td>
                            <td className="adminTD" width='8%' align='right'>
                                {txn.Amount}<br />{txn.Currency === 'BTC' ? translate('Bitcoin') : translate('Euro')}
                            </td>
                            <td className="adminTD" width='8%' align='right'>
                                {txn.UsedQuantity > 0 ? txn.OtherGasFees : txn.EstimatedOtherGasFees}<br />{txn.Currency === 'BTC' ? translate('Bitcoin') : ''}
                            </td>
                            <td className="adminTD" width='7%' align='right'>
                                {txn.CommissionAmount}<br />{translate('Euro')}
                            </td>
                            <td className="adminTD" width='7%' align='center'>
                                {(txn.TransactionType > 0) ? <span> &#9711;</span> : ''}
                            </td>
                        </tr>
                    })
                    }
                </tbody>
            </table>

            {isButtonClicked &&
                <>
                    <div className="gaps" />
                    <img width={80} src={require('../assets/images/loading.gif')} srcSet={require('../assets/images/loading.gif')} alt="loading" />
                </>
            }

            {totalRowCount > 0 &&
                <PaginationBar
                    rowsPerPage={ROWS_PER_PAGE}
                    totalRows={totalRowCount}
                    currentPage={currentPage}
                    paginate={onClickSearch} // Passing setCurrentPage to handle page change
                />
            }

            <div className="gaps-2x" />

        </div>

    );
};

const mapStateToProps = state => {
    return {
        searchResult: state.remote.transactionList
    };
};

export default connect(mapStateToProps, {
    actionGetTransactionList
})(TransactionList);
